import React, { memo, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchMyVisits from '../../../hooks/me/useFetchMyVisits';
import CommonLoader from '../../shared/loaders/CommonLoader';
import EmptyContent from '../../shared/table/EmptyContent';
import MyVisitsTable from './MyVisitsTable';

const VisitsList = () => {
  const navigate = useNavigate();
  const { loading, visits } = useFetchMyVisits();

  const handleVisitClick = (visit) => {
    navigate(`/vehicles/${visit.vin}/visits/${visit.id}`);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        <MyVisitsTable onVisitClick={handleVisitClick} visits={visits} loading={loading} />
        {visits.length === 0 && !loading && <EmptyContent title={'Список візитів порожній'} />}
      </div>
    </Suspense>
  );
};

export default memo(VisitsList);
